var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthidLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 818.6 264.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #2c1a5a;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #6d5aa3;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 79.66,
    y1: 133.29,
    x2: 10.9,
    y2: 6.78,
    gradientTransform: "translate(0 188) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9480ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 283.78,
    y1: 43.19,
    x2: 333.28,
    y2: 135.78,
    gradientTransform: "translate(0 188) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9480ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 211.72,
    y1: 140.52,
    x2: 151.21,
    y2: 17.68,
    gradientTransform: "translate(0 188) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9480ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 80.25,
    y1: 133.39,
    x2: 11.49,
    y2: 6.88,
    gradientTransform: "translate(0 188) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9480ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c1a5a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 284.37,
    y1: 43.29,
    x2: 333.87,
    y2: 135.88,
    gradientTransform: "translate(0 188) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9480ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c1a5a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 212.31,
    y1: 140.62,
    x2: 151.8,
    y2: 17.78,
    gradientTransform: "translate(0 188) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9480ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c1a5a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-1",
    d: "M12.91,181.3h0c-11.3-5.8-15.7-19.6-10-30.8,0,0,40.6-79.4,45.5-88.9,4.8-9.5,12.9-12.8,19.4-12.8h7.8c7.9,4,16.4,14.5,16.4,22.8,0,3.5-.8,7.1-2.5,10.4l-45.7,89.3c-5.9,11.3-19.7,15.8-30.9,10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-5",
    d: "M381.11,51.2c-2.8-1.4-6.9-2.4-11-2.4h-110.8l23.1,45.8h51l-28.8,55.9c-5.8,11.3-1.3,25.1,10,30.8v.2c11.3,5.8,25.1,1.1,30.8-10.2l45.7-89.2c5.7-11.3,1.2-25.1-10-30.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3",
    "data-name": "SVGID",
    className: "cls-6",
    d: "M144.61,181.3h0c-11.3-5.8-14.7-21.7-8.9-33l44.6-87.2c5.8-11.3,12-12.6,17.6-12.6l13.2,2.6c11.3,5.8,15.7,19.6,10,30.8l-45.7,89.5c-5.8,11.2-19.6,15.7-30.8,9.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-4",
    "data-name": "SVGID",
    className: "cls-8",
    d: "M108.31,139.2c0-10.5-8.5-19.1-19.1-19.1s-19.1,8.5-19.1,19.1,8.5,19.1,19.1,19.1c10.5,0,19.1-8.6,19.1-19.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M197.41,48.6c0,.1,41.8,0,41.8,0,7.4,0,12.1,2.8,16.1,9.4,3.9,6.5,54.9,106.1,58.1,111.9,3.2,5.8,6.8,12.8,12.5,14.2h-47.5c-8.3,0-13.1-6.2-18.7-17.9-5.6-11.8-52.1-103.5-54.4-107.8-2.1-4.4-3.8-7.2-7.9-9.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M177.81,160.7c0,12.7-9.9,23.6-21.9,23.6s-17.7-6-23.2-17c-4.1-8.4-50.2-98.5-53.3-104.3-3.2-5.8-6.1-11.8-12.1-14.2h48c8.8,0,12.1,6.2,17.7,17.9,4.8,9.7,31.4,59.3,38.8,76,1.9,4.5,6,11.3,6,18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-5",
    "data-name": "SVGID",
    className: "cls-8",
    d: "M240.41,22.4c0-11.3-9.1-20.4-20.4-20.4s-20.4,9.1-20.4,20.4,9.1,20.4,20.4,20.4c11.3,0,20.4-9.1,20.4-20.4"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-6",
    "data-name": "SVGID",
    className: "cls-9",
    d: "M13.5,181.2h0c-11.3-5.8-15.7-19.6-10-30.8,0,0,40.6-79.4,45.5-88.9,4.8-9.5,12.9-12.8,19.4-12.8h7.8c7.9,4,16.4,14.5,16.4,22.8,0,3.5-.8,7.1-2.5,10.4l-45.7,89.3c-5.9,11.3-19.7,15.8-30.9,10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-7",
    "data-name": "SVGID",
    className: "cls-4",
    d: "M381.7,51.1c-2.8-1.4-6.9-2.4-11-2.4h-110.8l23.1,45.8h51l-28.8,55.9c-5.8,11.3-1.3,25.1,10,30.8v.2c11.3,5.8,25.1,1.1,30.8-10.2l45.7-89.2c5.7-11.3,1.2-25.1-10-30.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M466,146.7v-1.5c0-10.3-5.1-15.4-15.3-15.4-7,0-13,2.3-18.2,7l-5.1-6c5.6-5.8,14-8.7,25.2-8.7,2.9,0,5.7.4,8.3,1.3,2.7.9,5,2.1,6.9,3.9,2,1.7,3.5,3.9,4.7,6.6,1.2,2.6,1.8,5.8,1.8,9.4v26.6c0,2.3.1,4.7.3,7.2.2,2.5.4,4.6.7,6.2h-8.1c-.3-1.4-.4-3-.6-4.7-.1-1.7-.2-3.3-.2-5h-.3c-2.5,4-5.4,6.9-8.7,8.6-3.4,1.7-7.4,2.6-12.3,2.6-2.6,0-5.2-.4-7.6-1.1-2.5-.7-4.6-1.8-6.6-3.3-1.9-1.5-3.4-3.3-4.6-5.5-1.1-2.2-1.7-4.7-1.7-7.6,0-4.8,1.3-8.6,3.8-11.4,2.5-2.8,5.6-4.8,9.4-6.2s7.8-2.2,12.1-2.5c4.3-.3,8.2-.5,11.8-.5M461.7,153.6c-2.1,0-4.8.1-8,.3s-6.2.7-9.2,1.5c-2.9.8-5.4,2.1-7.5,3.8s-3.1,4-3.1,7c0,2,.4,3.6,1.2,5,.8,1.4,1.9,2.5,3.2,3.4,1.4.9,2.9,1.5,4.5,1.9,1.7.4,3.3.6,5,.6,3.1,0,5.7-.5,8-1.5,2.2-1,4.1-2.4,5.7-4.1,1.5-1.7,2.7-3.8,3.4-6.1.7-2.3,1.1-4.8,1.1-7.4v-4.3h-4.3v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M536.9,183.2c-.2-1.6-.3-3.2-.3-4.8s-.1-3.2-.1-4.8h-.3c-.9,1.6-2.1,3.1-3.6,4.5-1.4,1.4-3.1,2.5-4.8,3.5-1.8,1-3.7,1.7-5.7,2.3-2,.5-4,.8-5.9.8-7.6,0-13.3-2-16.9-6s-5.5-9.8-5.5-17.2v-37.8h8.4v33c0,3.3.3,6.2.8,8.8.5,2.5,1.4,4.7,2.6,6.4s2.9,3.1,5,3.9c2.1.9,4.7,1.3,7.8,1.3.4,0,1.6-.2,3.6-.5s4-1.3,6.2-2.8,4.1-3.8,5.8-6.9c1.7-3.1,2.5-7.3,2.5-12.7v-30.5h8.4v46.5c0,1.6.1,3.6.2,6.1.1,2.5.3,4.8.4,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M596.1,131.3h-17.2v35.1c0,2.2.2,4,.6,5.4.4,1.4,1,2.5,1.8,3.2.8.8,1.7,1.3,2.7,1.6,1.1.3,2.2.4,3.5.4,1.4,0,2.9-.2,4.5-.6,1.5-.4,2.9-1,4.2-1.7l.4,7.8c-3.1,1.4-6.9,2.2-11.3,2.2-1.6,0-3.3-.2-5-.6-1.7-.4-3.3-1.2-4.8-2.4-1.4-1.2-2.6-2.8-3.6-4.8-.9-2-1.4-4.7-1.4-8v-37.5h-12.6v-7.6h12.6v-16.8h8.4v16.8h17.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 684.4,
    y: 94.6,
    width: 19.9,
    height: 90.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M725.5,94.6h29.8c7.2,0,14.1.8,20.6,2.4s12.2,4.2,17,7.8c4.8,3.6,8.7,8.3,11.5,14.1,2.8,5.8,4.3,12.8,4.3,21,0,7.3-1.4,13.7-4.1,19.3-2.8,5.6-6.5,10.2-11.1,14-4.7,3.8-10.1,6.6-16.2,8.6-6.1,2-12.5,2.9-19.2,2.9h-32.5M745.4,166.4h10.3c4.6,0,8.8-.5,12.8-1.4,3.9-.9,7.4-2.5,10.2-4.6,2.9-2.2,5.2-5,6.8-8.5,1.7-3.5,2.5-7.8,2.5-12.9,0-4.4-.8-8.3-2.5-11.5-1.7-3.3-3.9-6-6.7-8.1s-6.1-3.7-9.9-4.8c-3.8-1.1-7.7-1.6-11.9-1.6h-11.7v53.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M466,146.7v-1.5c0-10.3-5.1-15.4-15.3-15.4-7,0-13,2.3-18.2,7l-5.1-6c5.6-5.8,14-8.7,25.2-8.7,2.9,0,5.7.4,8.3,1.3,2.7.9,5,2.1,6.9,3.9,2,1.7,3.5,3.9,4.7,6.6,1.2,2.6,1.8,5.8,1.8,9.4v26.6c0,2.3.1,4.7.3,7.2.2,2.5.4,4.6.7,6.2h-8.1c-.3-1.4-.4-3-.6-4.7-.1-1.7-.2-3.3-.2-5h-.3c-2.5,4-5.4,6.9-8.7,8.6-3.4,1.7-7.4,2.6-12.3,2.6-2.6,0-5.2-.4-7.6-1.1-2.5-.7-4.6-1.8-6.6-3.3-1.9-1.5-3.4-3.3-4.6-5.5-1.1-2.2-1.7-4.7-1.7-7.6,0-4.8,1.3-8.6,3.8-11.4,2.5-2.8,5.6-4.8,9.4-6.2s7.8-2.2,12.1-2.5c4.3-.3,8.2-.5,11.8-.5h4.3ZM461.7,153.6c-2.1,0-4.8.1-8,.3s-6.2.7-9.2,1.5c-2.9.8-5.4,2.1-7.5,3.8s-3.1,4-3.1,7c0,2,.4,3.6,1.2,5,.8,1.4,1.9,2.5,3.2,3.4,1.4.9,2.9,1.5,4.5,1.9,1.7.4,3.3.6,5,.6,3.1,0,5.7-.5,8-1.5,2.2-1,4.1-2.4,5.7-4.1,1.5-1.7,2.7-3.8,3.4-6.1.7-2.3,1.1-4.8,1.1-7.4v-4.3h-4.3v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M545.6,183.2c-.2-2.2-.3-4.5-.4-7-.1-2.5-.2-4.5-.2-6.1v-46.5h-8.4v30.5c0,5.4-.9,9.7-2.5,12.7-1.7,3.1-3.6,5.3-5.8,6.9-2.2,1.5-4.2,2.5-6.2,2.8s-3.1.5-3.6.5c-3.1,0-5.7-.4-7.8-1.3-2.1-.9-3.7-2.2-5-3.9-1.2-1.7-2.1-3.9-2.6-6.4s-.8-5.5-.8-8.8v-33h-8.4v37.8c0,7.5,1.8,13.2,5.5,17.2,3.6,4,9.3,6,16.9,6,2,0,3.9-.3,5.9-.8,2-.6,3.9-1.3,5.7-2.3s3.4-2.1,4.8-3.5c1.4-1.4,2.6-2.8,3.6-4.5h.3c0,1.6,0,3.2.1,4.8,0,1.6.1,3.2.3,4.8h8.6v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M596.1,131.3h-17.2v35.1c0,2.2.2,4,.6,5.4.4,1.4,1,2.5,1.8,3.2.8.8,1.7,1.3,2.7,1.6,1.1.3,2.2.4,3.5.4,1.4,0,2.9-.2,4.5-.6,1.5-.4,2.9-1,4.2-1.7l.4,7.8c-3.1,1.4-6.9,2.2-11.3,2.2-1.6,0-3.3-.2-5-.6-1.7-.4-3.3-1.2-4.8-2.4-1.4-1.2-2.6-2.8-3.6-4.8-.9-2-1.4-4.7-1.4-8v-37.5h-12.6v-7.6h12.6v-16.8h8.4v16.8h17.2v7.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M613.9,184.7h8.4v-30.5c0-5.4.8-9.7,2.5-12.7,1.7-3.1,3.6-5.3,5.8-6.9,2.2-1.5,4.2-2.5,6.2-2.8s3.1-.5,3.6-.5c6.2,0,10.4,1.8,12.7,5.3s3.4,8.6,3.4,15.2v33h8.4v-37.8c0-7.5-1.8-13.2-5.5-17.2s-9.3-6-16.9-6c-2,0-3.9.3-5.9.8-2,.6-3.9,1.3-5.7,2.3s-3.4,2.1-4.8,3.5c-1.4,1.4-2.6,2.8-3.6,4.5h-.3v-40h-8.4v89.8h.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 684.4,
    y: 94.6,
    width: 19.9,
    height: 90.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M725.5,94.6h29.8c7.2,0,14.1.8,20.6,2.4s12.2,4.2,17,7.8c4.8,3.6,8.7,8.3,11.5,14.1,2.8,5.8,4.3,12.8,4.3,21,0,7.3-1.4,13.7-4.1,19.3-2.8,5.6-6.5,10.2-11.1,14-4.7,3.8-10.1,6.6-16.2,8.6-6.1,2-12.5,2.9-19.2,2.9h-32.5v-90.1h-.1ZM745.4,166.4h10.3c4.6,0,8.8-.5,12.8-1.4,3.9-.9,7.4-2.5,10.2-4.6,2.9-2.2,5.2-5,6.8-8.5,1.7-3.5,2.5-7.8,2.5-12.9,0-4.4-.8-8.3-2.5-11.5-1.7-3.3-3.9-6-6.7-8.1s-6.1-3.7-9.9-4.8c-3.8-1.1-7.7-1.6-11.9-1.6h-11.7v53.4h.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-8",
    "data-name": "SVGID",
    className: "cls-3",
    d: "M145.2,181.2h0c-11.3-5.8-14.7-21.7-8.9-33l44.6-87.2c5.8-11.3,12-12.6,17.6-12.6l13.2,2.6c11.3,5.8,15.7,19.6,10,30.8l-45.7,89.5c-5.8,11.2-19.6,15.7-30.8,9.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-9",
    "data-name": "SVGID",
    className: "cls-2",
    d: "M108.9,139.1c0-10.5-8.5-19.1-19.1-19.1s-19.1,8.5-19.1,19.1,8.5,19.1,19.1,19.1c10.5,0,19.1-8.6,19.1-19.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198,48.5c0,.1,41.8,0,41.8,0,7.4,0,12.1,2.8,16.1,9.4,3.9,6.5,54.9,106.1,58.1,111.9,3.2,5.8,6.8,12.8,12.5,14.2h-47.5c-8.3,0-13.1-6.2-18.7-17.9-5.6-11.8-52.1-103.5-54.4-107.8-2.1-4.4-3.8-7.2-7.9-9.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.4,160.6c0,12.7-9.9,23.6-21.9,23.6s-17.7-6-23.2-17c-4.1-8.4-50.2-98.5-53.3-104.3-3.2-5.8-6.1-11.8-12.1-14.2h48c8.8,0,12.1,6.2,17.7,17.9,4.8,9.7,31.4,59.3,38.8,76,1.9,4.5,6,11.3,6,18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID-10",
    "data-name": "SVGID",
    className: "cls-2",
    d: "M241,22.3c0-11.3-9.1-20.4-20.4-20.4s-20.4,9.1-20.4,20.4,9.1,20.4,20.4,20.4c11.3,0,20.4-9.1,20.4-20.4"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M812.1,184.4c-.9,0-1.7-.2-2.5-.5s-1.5-.8-2.1-1.4-1.1-1.3-1.4-2.1c-.3-.8-.5-1.6-.5-2.5s.2-1.7.5-2.5.8-1.5,1.4-2,1.3-1.1,2.1-1.4c.8-.3,1.6-.5,2.5-.5s1.7.2,2.5.5,1.5.8,2.1,1.4c.6.6,1.1,1.3,1.4,2,.3.8.5,1.6.5,2.5s-.2,1.7-.5,2.5-.8,1.5-1.4,2.1c-.6.6-1.3,1.1-2.1,1.4-.7.4-1.6.5-2.5.5ZM812.1,182.9c.9,0,1.7-.2,2.5-.7.7-.4,1.3-1,1.8-1.8.4-.7.7-1.6.7-2.5s-.2-1.7-.7-2.5c-.4-.7-1-1.3-1.8-1.8-.7-.4-1.6-.7-2.5-.7s-1.7.2-2.5.7c-.7.4-1.3,1-1.8,1.8-.4.7-.7,1.6-.7,2.5s.2,1.7.7,2.5c.4.7,1,1.3,1.8,1.8.8.5,1.6.7,2.5.7ZM810,181v-6.2h2.7c.6,0,1.1.2,1.5.6.4.4.6.9.6,1.4,0,.4-.1.7-.3,1s-.5.6-.9.8l1.2,2.4h-1.2l-1.1-2.2h-1.5v2.2h-1ZM811,177.9h1.7c.3,0,.5-.1.7-.3s.3-.4.3-.7-.1-.6-.3-.7c-.2-.2-.4-.3-.7-.3h-1.7v2Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.29,236.47c0,4.52-2.52,6.83-5.25,8.24,4.31,1.47,7.3,3.94,7.3,8.98,0,6.62-5.41,10.13-13.6,10.13H4.73v-36.75h16.49c7.4,0,12.08,3.62,12.08,9.4ZM26.83,237.52c0-2.99-2.31-4.72-6.46-4.72h-9.29v9.77h8.82c4.15,0,6.93-1.63,6.93-5.04ZM28.88,253.01c0-3.15-2.47-4.99-7.56-4.99h-10.24v10.08h10.71c4.41,0,7.09-1.73,7.09-5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M49.46,227.08v36.75h-6.46v-36.75h6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.81,264.46c-11.29,0-19.17-8.56-19.17-18.95s7.98-19.06,19.27-19.06,19.17,8.56,19.17,18.95-7.98,19.06-19.27,19.06ZM76.81,232.38c-7.3,0-12.39,5.83-12.39,13.02s5.2,13.13,12.5,13.13,12.39-5.83,12.39-13.02-5.2-13.13-12.5-13.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.96,254.8h-.21l-11.5-17.22v26.25h-6.35v-36.75h6.88l11.18,17.38,11.18-17.38h6.88v36.75h-6.46v-26.36l-11.6,17.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M176.71,232.85h-20.79v9.56h18.43v5.78h-18.43v9.87h21.05v5.78h-27.51v-36.75h27.25v5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M200.18,263.83h-6.51v-30.77h-11.66v-5.99h29.82v5.99h-11.66v30.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M242.23,263.83l-9.03-12.81h-8.09v12.81h-6.46v-36.75h16.38c8.45,0,13.65,4.46,13.65,11.66,0,6.09-3.62,9.77-8.77,11.18l9.92,13.91h-7.61ZM234.52,232.96h-9.4v12.34h9.45c4.62,0,7.56-2.42,7.56-6.2,0-4.04-2.83-6.14-7.61-6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M263.44,227.08v36.75h-6.46v-36.75h6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M290.32,264.46c-10.71,0-18.69-8.35-18.69-18.95s7.82-19.06,18.96-19.06c6.77,0,10.87,2.36,14.39,5.72l-4.15,4.78c-2.94-2.73-6.09-4.57-10.29-4.57-7.04,0-12.13,5.78-12.13,13.02s5.09,13.13,12.13,13.13c4.52,0,7.4-1.84,10.55-4.78l4.15,4.2c-3.83,3.99-8.03,6.51-14.91,6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M362.93,263.83h-6.83l-3.73-8.87h-17.38l-3.78,8.87h-6.62l16.17-37.02h5.99l16.17,37.02ZM343.66,234.53l-6.3,14.7h12.65l-6.35-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M398.79,247.92c0,10.97-6.2,16.49-15.8,16.49s-15.65-5.51-15.65-16.17v-21.16h6.46v20.9c0,6.83,3.52,10.5,9.29,10.5s9.24-3.47,9.24-10.24v-21.16h6.46v20.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M423.2,263.83h-6.51v-30.77h-11.66v-5.99h29.82v5.99h-11.66v30.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M448.13,248.34v15.49h-6.46v-36.75h6.46v15.28h17.54v-15.28h6.46v36.75h-6.46v-15.49h-17.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M508.82,232.85h-20.79v9.56h18.43v5.78h-18.43v9.87h21.05v5.78h-27.51v-36.75h27.25v5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M542.42,227.08h6.35v36.75h-5.41l-20.27-26.15v26.15h-6.35v-36.75h5.99l19.69,25.41v-25.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M573.77,263.83h-6.51v-30.77h-11.66v-5.99h29.82v5.99h-11.66v30.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M599.07,227.08v36.75h-6.46v-36.75h6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M625.95,264.46c-10.71,0-18.69-8.35-18.69-18.95s7.82-19.06,18.96-19.06c6.77,0,10.87,2.36,14.39,5.72l-4.15,4.78c-2.94-2.73-6.09-4.57-10.29-4.57-7.04,0-12.13,5.78-12.13,13.02s5.09,13.13,12.13,13.13c4.52,0,7.4-1.84,10.55-4.78l4.15,4.2c-3.83,3.99-8.03,6.51-14.91,6.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M682.81,263.83h-6.83l-3.73-8.87h-17.38l-3.78,8.87h-6.62l16.17-37.02h5.99l16.17,37.02ZM663.54,234.53l-6.3,14.7h12.65l-6.35-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M699.92,263.83h-6.51v-30.77h-11.66v-5.99h29.82v5.99h-11.66v30.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M725.22,227.08v36.75h-6.46v-36.75h6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M752.58,264.46c-11.29,0-19.17-8.56-19.17-18.95s7.98-19.06,19.27-19.06,19.17,8.56,19.17,18.95-7.98,19.06-19.27,19.06ZM752.58,232.38c-7.3,0-12.39,5.83-12.39,13.02s5.2,13.13,12.5,13.13,12.39-5.83,12.39-13.02-5.2-13.13-12.5-13.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M805.34,227.08h6.35v36.75h-5.41l-20.27-26.15v26.15h-6.35v-36.75h5.99l19.69,25.41v-25.41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthidLogo);
export default __webpack_public_path__ + "static/media/authid-logo.1f2bdb95a5a0b4a06ed8fca3abc2f305.svg";
export { ForwardRef as ReactComponent };